<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
    v-if="isDataLoadedFromServer"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          {{ $t("add_new_pickup_order") }}
        </h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="">
        <!--begin::Body-->
        <v-stepper v-model="step" flat tile class="ma-0 pa-0 h-100">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              {{ $t("select_type_of_pickup") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
              {{
                formData.pickup_type === 1
                  ? $t("stock_collection_form")
                  : formData.pickup_type === 2
                  ? $t("cross_dock_collection_form")
                  : ""
              }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card elevation="0" class="mb-4 pt-4 h-100">
                <form
                  id="createForm"
                  class="pa-3 pt-0 pb-0 row"
                  style="margin-bottom: 339px"
                >
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-12"
                    v-if="!$store.getters.isClient"
                  >
                    <v-select
                      v-model="formData.customer"
                      :label="$t('customer')"
                      item-text="text"
                      item-value="index"
                      :items="serverData.clients"
                      clearable
                      outlined
                      dense
                      :error-messages="customerErrors"
                      @input="$v.formData.customer.$touch()"
                      @blur="$v.formData.customer.$touch()"
                    ></v-select>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-6 col-12">
                    <v-select
                      v-model="formData.pickup_type"
                      :label="$t('pickup_type')"
                      item-text="text"
                      item-value="index"
                      :items="serverData.pickup_types"
                      clearable
                      dense
                      outlined
                      :error-messages="pickup_typeErrors"
                      @input="$v.formData.pickup_type.$touch()"
                      @blur="$v.formData.pickup_type.$touch()"
                    ></v-select>
                  </div>
                </form>
                <div class="d-flex flex-row-reverse mt-4">
                  <button
                    class="btn btn-info px-5 py-3 ls1 mx-6"
                    @click="handleStage1"
                  >
                    {{ $t("next") }}
                  </button>
                  <!--                  <v-btn-->
                  <!--                    class="ml-1 mr-sm-6"-->
                  <!--                    color="primary"-->
                  <!--                    @click="handleStage1"-->
                  <!--                  >-->
                  <!--                    Next-->
                  <!--                  </v-btn>-->
                </div>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2" class="ma-0 pa-0 h-100">
              <v-card class="ma-0 pa-0 h-100" elevation="0">
                <component
                  ref="step2Form"
                  v-bind:is="step2FormComponent"
                  :setData="setForm2Data"
                  :actionFuntion="handleStage2"
                  :serverData="serverData"
                  :pageLoader="pageLoader"
                  :initData="false"
                  :userId="userId"
                  :customer_id="customerId"
                  :getStep2Data="getStep2Data"
                ></component>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import StockForm from "@/own/components/shipping/pickupOrders/pickupTypeForms/StockForm";
import CrossDockForm from "@/own/components/shipping/pickupOrders/pickupTypeForms/CrossDockForm";

export default {
  name: "AddItem",
  mixins: [validationMixin],
  components: {
    // SkuDatatable,
  },
  validations: {
    formData: {
      customer: {
        required: requiredIf(function () {
          return !this.isClient;
        }),
      },
      pickup_type: { required },
    },
  },
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    step: 1,
    step2Form: null,
    serverData: null,
    isDataEnteredToForm: false,
    formData: {
      customer: null,
      pickup_type: null,
      // skus: [],
      // parcel: {},
    },
  }),
  beforeMount() {
    this.loadDataFromServer();
  },
  methods: {
    // setSkus(item) {
    //   this.formData.skus = [...item];
    // },
    async getStep2Data() {
      this.pageLoader(true);
      await ApiService.post("/shipping/pickup_orders/customer-addresses", {
        customer_id: this.customerId,
      })
        .then((response) => {
          let data = this.serverData;
          data.collection_addresses = response.data.addresses;
          this.serverData = data;
          this.$refs.step2Form.collection_addresses = response.data.addresses;
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    handleStage1() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.formData.pickup_type == 1) {
        this.step2Form = StockForm;
      } else if (this.formData.pickup_type == 2) {
        this.step2Form = CrossDockForm;
      }
      this.$nextTick(() => {
        // TODO: get collection address from api
        this.getStep2Data().then(() => {
          if (!this.isDataEnteredToForm) {
            this.$refs.step2Form.resetCreateForm();
          }
          this.step = 2;
          this.isDataEnteredToForm = true;
        });
      });
    },
    handleStage2(action = "submit") {
      if (action == "submit") {
        this.submitCreateForm();
      } else {
        this.step = 1;
      }
    },
    setForm2Data(item) {
      let copy = { ...this.formData, ...item };
      // copy.values = item;
      this.formData = copy;
    },
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      // if ("email" in vueObj.$v[fieldName]) {
      //   !vueObj.$v[fieldName].email &&
      //     errors.push(this.$t("validation_this_email_address_is_invalid"));
      // }
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    loadDataFromServer() {
      this.pageLoader(true);
      ApiService.post("/shipping/pickup_orders/create")
        .then((response) => {
          this.serverData = response.data;
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    toggleModal() {
      this.resetCreateForm();
      this.dialog = !this.dialog;
      this.step = 1;
    },
    validateData() {
      return true;
    },
    convertToFormData() {
      return this.formData;
    },
    submitCreateForm() {
      this.pageLoader(true);
      let data = this.convertToFormData();
      if (data.destination_address_type === 0) {
        delete data.warehouse_id;
      }
      // else if (data.destination_address_type === 1) {
      //   delete data.destination_country_id;
      // }
      ApiService.post("/shipping/pickup_orders/store", data)
        .then(() => {
          Swal.fire({
            title: this.$t("notificationtitle_created"),
            text: this.$t("record_has_been_successfully_added"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetCreateForm() {
      this.$v.$reset();

      this.formData = {
        customer: null,
        pickup_type: null,
        // skus: [],
        // parcel: {},
      };
      if (this.step2Form) {
        try {
          this.$refs.step2Form.resetCreateForm();
        } catch (e) {
          // console.error(e);
        }
      }
    },
  },
  computed: {
    // getDestinationAddressType: function () {
    //   let res = null;
    //   if (this.serverData && this.serverData.destination_address_types) {
    //     if (this.serverData.destination_address_types.length)
    //       res = this.serverData.destination_address_types[0].index;
    //   }
    //   console.log("res", res);
    //   return res;
    // },
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
    step2FormComponent: function () {
      return this.step2Form;
    },
    customerErrors() {
      return this.handleFormValidation("customer", this);
    },
    pickup_typeErrors() {
      return this.handleFormValidation("pickup_type", this);
    },
    isClient() {
      return this.$store.getters.isClient;
    },
    userId: function () {
      return this.isClient ? false : this.formData.customer;
    },
    customerId: function () {
      return this.isClient
        ? this.$store.getters.currentUser.data.customer_id
        : this.formData.customer;
    },
  },
  watch: {
    "formData.pickup_type": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.isDataEnteredToForm = false;
      }
    },
  },
};
</script>
<style></style>
